import React, { useEffect, useState } from 'react';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import Form from '../../components/Form/Form';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";
import DocumentTemplates_popup_CreateDocumentTemplate from './Popups/DocumentTemplates_popup_CreateDocumentTemplate';

const DocumentTemplates: React.FC = () => {
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/documenttemplates')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }
    function deleteRow(rowData) {
        DataService.delete('api/v1/documenttemplates/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Attachment type', dataProp: 'attachmentType.name', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Language', dataProp: 'language', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Output Type', dataProp: 'documentOutputType.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Data source', dataProp: 'attachmentType.dataSourceType.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Active', dataProp: 'isActive', dataType: 'bool', filterInfo: { filterType: 'CheckboxList' } },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditDocumentTemplates)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: ()=>setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title="Document templates" >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new template"} onClick={() => { setShowPopup(true); }} appFunction={ApplicationFunctions.EditDocumentTemplates} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <Card title='Document templates'
                        content={
                            <DataTable
                                name='dtDocumentTemplates'
                                tableData={data}
                                colInfos={colInfos}
                                navigateTitle='Document template'
                                navigateUrl='/plm/Communication/DocumentTemplate/'
                            />
                        }
                    />
                </Form.Content>
            </Form>
            {showPopup && <DocumentTemplates_popup_CreateDocumentTemplate show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </div>
    );
}
export default DocumentTemplates;